module.exports = __webpack_public_path__ + "assets/img/icon_sound.06d7b4e5.svg";